import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FiX, FiCheck, FiAlertCircle, FiInfo } from 'react-icons/fi';

const Toast = ({ message, type = 'info', onClose, id }) => {
  const getToastStyles = (type) => {
    switch (type) {
      case 'success':
        return {
          icon: <FiCheck className="w-6 h-6" />,
          gradient: 'from-green-500 to-white',
          iconColor: 'text-green-700'
        };
      case 'error':
        return {
          icon: <FiAlertCircle className="w-6 h-6" />,
          gradient: 'from-red-500 to-white',
          iconColor: 'text-red-700'
        };
      case 'warning':
        return {
          icon: <FiInfo className="w-6 h-6" />,
          gradient: 'from-yellow-500 to-white',
          iconColor: 'text-yellow-700'
        };
      default:
        return {
          icon: <FiInfo className="w-6 h-6" />,
          gradient: 'from-blue-500 to-white',
          iconColor: 'text-blue-700'
        };
    }
  };

  const { icon, gradient, iconColor } = getToastStyles(type);

  return (
    <motion.div
      initial={{ opacity: 0, y: -50, scale: 0.3 }}
      animate={{ opacity: 1, y: 60, scale: 1 }}
      exit={{ opacity: 0, scale: 0.5, transition: { duration: 0.2 } }}
      transition={{
        type: "spring",
        stiffness: 500,
        damping: 30,
        mass: 1
      }}
      className={`
        min-w-[300px] p-4 rounded-lg shadow-lg
        bg-gradient-to-r ${gradient}
        flex items-center gap-3
      `}
    >
      <span className={iconColor}>
        {icon}
      </span>
      
      <div className="flex-1">
        {message.title && (
          <h4 className="font-semibold text-gray-800">
            {message.title}
          </h4>
        )}
        <p className="text-gray-600">
          {message.content}
        </p>
      </div>

      <button
        onClick={() => onClose(id)}
        className="p-1 rounded-full hover:bg-black/5 transition-colors"
      >
        <FiX className="w-5 h-5 text-gray-600" />
      </button>
    </motion.div>
  );
};

// ToastContainer component to manage multiple toasts
const ToastContainer = ({ messages, onClose }) => {
  return (
    <div className="fixed top-4 right-4 z-[999] space-y-4">
      <AnimatePresence>
        {messages.map((msg) => (
          <Toast
            key={msg.id}
            id={msg.id}
            message={msg}
            type={msg.type}
            onClose={onClose}
          />
        ))}
      </AnimatePresence>
    </div>
  );
};

export default ToastContainer;
